import { render, staticRenderFns } from "./btn-green.vue?vue&type=template&id=108da2b7&"
import script from "./btn-green.vue?vue&type=script&lang=js&"
export * from "./btn-green.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/btn-green/btn-green.vue
// module id = 532
// module chunks = 0